import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import axios from '../../utils/axiosInterceptor';

import {
    Box, Paper, Fab, Typography, CircularProgress, Button, Container
} from '@mui/material';

import {
    DataGrid,
    gridPageCountSelector,
    GridPagination,
    useGridApiContext,
    GridToolbar,
    useGridSelector,
} from '@mui/x-data-grid';
import MuiPagination from '@mui/material/Pagination';

// Custom components and functions
import CustomStatusChip from '../../utils/components/CustomStatusChip';
import useWindowDimensions from '../../utils/functions/useWindowDimensions';
import LocaleTextDataGrid from '../../utils/functions/LocaleTextDataGrid';
import { getDate } from '../../utils/functions/Utils';

const TablaPedidos = () => {

    let navigate = useNavigate();
    const auth = useSelector((state) => state.auth);

    const [data, setData] = useState([{}]);
    const [loading, setLoading] = useState(true);
    const [selected, setSelected] = useState('');
    const { height } = useWindowDimensions();

    useEffect(() => {
        if (auth.user.rol !== "Admin") {
            navigate('/dashboard');
        }
        document.title = 'Tabla de pedidos';
    }, [auth])

    const getData = async () => {
        setLoading(true);
        try {
            const res = await axios.get('/api/batchs/');
            if (res.status === 200 && res.data.length > 0) {
                if (res.data.length <= 1) {
                    res.data[0].fechaDePedido = getDate(res.data[0].fechaDePedido);
                    res.data[0].fechaDeEntrega = getDate(res.data[0].fechaDeEntrega);
                    setData(res.data);
                }
                else {
                    const tmp = res.data.map((item) => {
                        item.fechaDePedido = getDate(item.fechaDePedido);
                        item.fechaDeEntrega = getDate(item.fechaDeEntrega);
                        return item;
                        // if(item.cotizacion) {
                        //     return {...item, monto: `$ ${formatMoney(item.cotizacion.total)}`}
                        // } else {
                        //     return {...item, monto: `$ ${formatMoney(0)}`}
                        // }
                    });
                    setData(tmp);
                }
                setLoading(false);
                document.title = 'Tabla de pedidos';
            } else {
                setData([]);
                setLoading(false);
            }
        } catch (err) {
            console.log(err);
            alert('Ocurrió un error al cargar los pedidos, favor de intentarlo mas tarde');
            setLoading(false);
        }
    }

    useEffect(() => {
        getData();
    }, [])

    const renderProducts = () => {
        if (data.length === 0) return null;
        else {
            return (
                <div>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center' }}>
                        <Button size='small' variant='outlined' onClick={() => navigate('/pedidos')}><i className='fad fa-arrow-left'></i> &nbsp;&nbsp;Regresar</Button>
                        <Typography variant='h5' align='left' sx={{ mt: 1, mb: 1, fontWeight: 700, ml: 3 }}>Pedidos de productos</Typography>
                    </div>
                    <DataGrid
                        autoPageSize={true}
                        sx={{ '& .MuiDataGrid-toolbarContainer': { position: 'fixed', top: '70px', right: '24px' }, '& .MuiButtonBase-root': { color: 'comp.gray' }, '& .MuiDataGrid-row': { backgroundColor: 'comp.tableBg', color: 'text.primary', height: 'auto' }, '& .MuiDataGrid-columnHeader': { backgroundColor: 'comp.tableHeaderBg', color: 'text.primary' } }}
                        style={{ height: `${height - 120}px`, width: '100%', overflow: 'hidden' }}
                        localeText={LocaleTextDataGrid}
                        rows={data}
                        getRowId={(row) => row._id}
                        onCellClick={(e) => { setSelected(e.row._id) }}
                        onCellDoubleClick={(e) => { navigate(`/pedidos/editarPedido/${e.row._id}`, { target: '_blank' }) }}
                        columns={[
                            { field: 'consecutivo', headerName: 'Consecutivo', flex: 1, minWidth: 60, maxWidth: 70, headerAlign: 'center', align: 'center' },
                            { field: 'categoria', headerName: 'Categoria', flex: 1, minWidth: 200, headerAlign: 'center', align: 'center' },
                            { field: 'noPedido', headerName: '# Pedido', align: 'center', headerAlign: 'center', flex: 1, minWidth: 200 },
                            {
                                field: 'estatus',
                                flex: 1,
                                minWidth: 200,
                                headerName: 'Estatus',
                                headerClassName: 'text-bold',
                                align: 'center',
                                headerAlign: 'center',
                                renderCell: (params) => (
                                    <CustomStatusChip estatus={params.row.estatus} label={params.row.estatus} />
                                ),
                            },
                            { field: 'proveedor', flex: 1, headerName: 'Proveedor', align: 'center', headerAlign: 'center', minWidth: 200 },
                            { field: 'fechaDePedido', flex: 1, headerName: 'Fecha de Pedido', align: 'center', headerAlign: 'center', minWidth: 200 },
                            { field: 'fechaDeEntrega', flex: 1, headerName: 'Fecha de Entrega', align: 'center', headerAlign: 'center', minWidth: 200 },
                        ]}
                        pagination
                        slots={{
                            pagination: CustomPagination,
                            toolbar: GridToolbar
                        }}
                        initialState={{
                            ...data.initialState,
                            pagination: { paginationModel: { pageSize: 25 } },
                        }}
                    />
                </div>
            )
        }
    }

    return (
        <Container maxWidth='xxl' sx={{ width: '100%', overflow: 'hidden', margin: '0px', padding: '4px 4px !important' }}>
            <Paper>
                {loading ?
                    <Box style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', marginTop: '128px' }}>
                        <CircularProgress size='5em' color='primary' />
                    </Box> :

                    <>
                        <Link to='/pedidos/agregarPedido'>
                            <Fab aria-label="add" color='success' style={{ position: 'fixed', bottom: '8px', left: '8px', zIndex: '10', color: '#FFF' }}>
                                <i className="fad fa-plus fa-2x"></i>
                            </Fab>
                        </Link>

                        {selected !== '' ?
                            <div>
                                <Link target='_blank' to={{ pathname: '/pedidos/editarPedido/' + selected, state: { id: selected } }} style={{ textDecoration: 'none' }}>
                                    <Fab aria-label="add" color='warning' style={{ position: 'fixed', bottom: '8px', left: '165px', zIndex: '10', color: '#FFF' }}>
                                        <i className="fad fa-edit fa-2x"></i>
                                    </Fab>
                                </Link>
                            </div>
                            : null}
                        {renderProducts()}
                    </>
                }
            </Paper>
        </Container>
    );
}

function Pagination({ page, onPageChange, className }) {
    const apiRef = useGridApiContext();
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    return (
        <MuiPagination
            color="primary"
            className={className}
            count={pageCount}
            page={page + 1}
            onChange={(event, newPage) => {
                onPageChange(event, newPage - 1);
            }}
        />
    );
}

function CustomPagination(props) {
    return <GridPagination ActionsComponent={Pagination} {...props} />;
}

export default TablaPedidos;